export default __webpack_public_path__ + "static/media/nova_oprema1.c27d7ad4.png";